import React from 'react';
import PropTypes from 'prop-types';
import LogoImage from 'Components/logo';
import errorMessage from 'Misc/error-message';

import './error-screen.scss';

const ErrorScreen = (props) => (
  <div className="error-screen">
    <LogoImage />
    <div className="error-screen__text">
      { errorMessage(props.state.lastError, props.settings.APP_NAME) }
    </div>
  </div>
);

export default ErrorScreen;

ErrorScreen.propTypes = {
  state: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/error-screen/index.js